// import { CSSProperties, ReactNode } from "react";
import { CLOSE_LOADER, OPEN_LOADER } from "../../actions/constants";

interface LoaderActionInterface {
  type:string;
  payload: {
    message?: string;
    loaderType?: string;
  };
}

interface LoaderInterface {
  LoaderOpened: boolean;
  message?: string;
  loaderType?: string;
}

const initialLoaderState: LoaderInterface = {
  LoaderOpened: false,
  message: undefined,
  loaderType: undefined,
};


const loaderReducer = (state = initialLoaderState, action: LoaderActionInterface) => {
  switch (action.type) {
    case CLOSE_LOADER: {
      return { ...state, LoaderOpened: false,message: action.payload.message, loaderType:action.payload.loaderType };
    }
    case OPEN_LOADER: {
      return { ...state, LoaderOpened: true, message: action.payload.message, loaderType:action.payload.loaderType };
    }
    default: {
      return state;
    }
  }
};

export default loaderReducer;
